import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import FormCard from "../../../../../Lib/FormCard";
import FormInput from "../../../../../Lib/FormInput";
import FormSelect from "../../../../../Lib/FormSelect";
import { FETCH_ROOM_REQUEST } from "../../../../../Utils/Constant";
import Select from "react-select";
import { toast } from "react-toastify";
import { getBaseUrl } from "../../../../../Redux/Config/AppConfig";
import ReactDOM from "react-dom";

// Move the modal to a separate component at the top level
function AddPackageModal({ show, loading, errors, form, onChange, onClose, onSave }) {
  if (!show) return null;
  return ReactDOM.createPortal(
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Package</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          {/* No <form> here, just a div */}
          <div className="modal-body">
            <div className="mb-3">
              <label className="form-label">Package Name <span className="text-danger">*</span></label>
              <input type="text" name="package_name" className={`form-control${errors.package_name ? ' is-invalid' : ''}`} value={form.package_name} onChange={onChange} autoComplete="off" />
              {errors.package_name && <div className="invalid-feedback">{errors.package_name}</div>}
            </div>
            <div className="mb-3">
              <label className="form-label">Description <span className="text-danger">*</span></label>
              <textarea name="package_description" className={`form-control${errors.package_description ? ' is-invalid' : ''}`} value={form.package_description} onChange={onChange} autoComplete="off" />
              {errors.package_description && <div className="invalid-feedback">{errors.package_description}</div>}
            </div>
            <div className="mb-3">
              <label className="form-label">Price <span className="text-danger">*</span></label>
              <input type="number" name="package_price" className={`form-control${errors.package_price ? ' is-invalid' : ''}`} value={form.package_price} onChange={onChange} autoComplete="off" />
              {errors.package_price && <div className="invalid-feedback">{errors.package_price}</div>}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>Cancel</button>
            <button type="button" className="btn btn-dark" onClick={onSave} disabled={loading}>{loading ? 'Saving...' : 'Save'}</button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}

const RoomDetails = ({
  formData,
  handleChange,
  handleRoomChange,
  isViewOnly = false,
  isEditingMode = false,
  packageList = [],
  onPackageAdded,
}) => {
  const dispatch = useDispatch();
  const [totalRooms, setTotalRooms] = useState([]);
  const [availableRooms, setAvailableRooms] = useState([]);
  const baseUrl=getBaseUrl()
  const { rooms } = useSelector((state) => state.frontdesk);
  const [showAddPackageModal, setShowAddPackageModal] = useState(false);
  const [addPkgLoading, setAddPkgLoading] = useState(false);
  const [addPkgForm, setAddPkgForm] = useState({
    package_name: "",
    package_description: "",
    package_price: ""
  });
  const [addPkgErrors, setAddPkgErrors] = useState({});

  const handleAddPkgChange = (e) => {
    const { name, value } = e.target;
    setAddPkgForm((prev) => ({ ...prev, [name]: value }));
    setAddPkgErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateAddPkg = () => {
    const errs = {};
    if (!addPkgForm.package_name.trim()) errs.package_name = "Name required";
    if (!addPkgForm.package_description.trim()) errs.package_description = "Description required";
    if (!addPkgForm.package_price || isNaN(addPkgForm.package_price) || Number(addPkgForm.package_price) <= 0) errs.package_price = "Valid price required";
    setAddPkgErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleAddPkgSave = async () => {
    if (!validateAddPkg()) return;
    setAddPkgLoading(true);
    try {
      const token = localStorage.getItem("token");
      const hotel_id = localStorage.getItem("hotel_id");
      const res = await fetch(`${baseUrl}/room/package`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          package_name: addPkgForm.package_name,
          package_description: addPkgForm.package_description,
          package_price: parseFloat(addPkgForm.package_price),
          hotel_id
        })
      });
      const data = await res.json();
      if (res.ok) {
        toast.success("Package created successfully!");
        setShowAddPackageModal(false);
        setAddPkgForm({ package_name: "", package_description: "", package_price: "" });
        setAddPkgErrors({});
        if (typeof onPackageAdded === 'function') onPackageAdded();
      } else {
        toast.error(data?.message || "Failed to add package");
      }
    } catch (err) {
      toast.error("Error adding package");
    } finally {
      setAddPkgLoading(false);
    }
  };

  useEffect(() => {
    if (formData.rooms) {
      setTotalRooms(formData.rooms)
    }
  }, [formData.rooms])
  useEffect(() => {
    if (rooms?.data?.length) {
      const totalAvailableRooms = rooms?.data?.reduce((count, roomType) => {
        const available = roomType.room.length || 0;
        return count + available;
      }, 0);

      let roomData = [];
      for (let i = 0; i < totalAvailableRooms; i++) {
        roomData.push({ value: i + 1, label: i + 1 });
      }
      setAvailableRooms(roomData);
    }
  }, [rooms]);
  function formatLocalDateTime(date) {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
  
    return `${year}-${month}-${day}T${hours}:${minutes}:00`;
  }
  
  useEffect(() => {
    if (
      !rooms?.data?.length ||
      (!(isViewOnly || isEditingMode) &&
        formData.check_in_date_time &&
        formData.check_out_date_time)
    ) {
      let dates = {};
      if (formData.check_in_date_time && formData.check_out_date_time) {
        let start_date = formatLocalDateTime(formData?.check_in_date_time);
        let end_date = formatLocalDateTime(formData?.check_out_date_time);
        dates = { start_date, end_date };
      }
      dispatch({ type: FETCH_ROOM_REQUEST, payload: { ...dates } });
    }
  }, [dispatch, formData.check_in_date_time, formData.check_out_date_time]);

  const roomTypeOptions = rooms?.data?.length
    ? rooms?.data?.map((type) => ({
      value: type.id,
      label: type.room_type,
    }))
    : [];

  const selectedRoomTypeData = useMemo(() => {
    if (Array.isArray(formData.rooms)) {
      // If formData.rooms is an array (multiple rooms), get based on index
      return (i) =>
        rooms?.data?.find((type) => type.id === formData?.rooms[i]?.room_type);
    } else {
      // If formData.room_type is a single value, get based on that
      return rooms?.data?.find((type) => type.id === formData.room_type);
    }
  }, [rooms, formData]);

  const roomNoOptions = (i) => {
    let data = selectedRoomTypeData(i);
    // return data?.room?.filter((items) =>!formData?.rooms?.some(item => item.room_id === items.id))?.map((room) => ({
    //   value: room.id,
    //   label: room.room_number,
    // }))
    return (
      data?.room?.map((room) => ({
        value: room.id,
        label: room.room_number,
      })) || []
    );
  };

  const selectedRoomType = (i) => {
    return (
      roomTypeOptions?.find(
        (option) => option?.value === formData?.rooms[i]?.room_type
      )?.label || "N/A"
    );
  };

  const selectedRoomNo = (i) => {
    let data = roomNoOptions(i);
    return (
      data?.find((option) => option?.value === formData?.rooms[i]?.room_id)
        ?.label || "N/A"
    );
  };

  useEffect(() => {
    if (!(isEditingMode || isViewOnly) && formData.total_rooms > 0) {
      let arr = [];
      for (let i = 0; i < formData.total_rooms; i++) {
        arr.push(i + 1);
      }
      setTotalRooms(arr);
    }
  }, [formData.total_rooms]);

//  useEffect(() => {
//    if (!(isEditingMode || isViewOnly) && formData.total_rooms > 0) {
//      const updatedRooms = [...(formData.rooms || [])];
//      const totalCount = formData.total_rooms;

//      while (updatedRooms.length < totalCount) {
//        updatedRooms.push({ room_type: "", room_id: "" });
//      }
//      if (updatedRooms.length > totalCount) {
//        updatedRooms.length = totalCount; // truncate if more than total
//      }

//      handleChange({
//        target: {
//          name: "rooms",
//          value: updatedRooms,
//        },
//      });

//      setTotalRooms(Array.from({ length: totalCount }, (_, i) => i + 1));
//    }
//  }, [formData.total_rooms, formData.rooms, isEditingMode, isViewOnly]);

  const packageOptions = useMemo(() => {
    return (
      packageList?.map((pkg) => ({
        label: pkg.name,
        value: pkg.id,
        price: pkg.price
      })) || []
    );
  }, [packageList]);
  
  return (
    <>
      <FormCard title="Room Details">
        <div className="row">
          <div className="col-md-6 mb-3">
            {isViewOnly ? (
              <div className="view-only-field">
                <label className="form-label">No. of Rooms</label>
                <div className="view-only-value">{formData.total_rooms || 1}</div>
              </div>
            ) : (
              <>
                {/* <button type="button" className="btn btn-dark" data-bs-toggle="modal" data-bs-target="#add-image">+</button> */}
                <FormSelect
                  label="No. of Rooms"
                  name="total_rooms"
                  // type="number"
                  // disabled
                  // max={}
                  options={availableRooms}
                  value={(formData.total_rooms || formData.rooms?.length) || ""}
                  onChange={handleChange}
                  required
                // disabled={isViewOnly}
                />
              </>
            )}
          </div>
          <div className="col-md-6 mb-3">
            {isViewOnly ? (
              <div className="view-only-field">
                <label className="form-label">Packages</label>
                <div className="view-only-value">
                  {(formData?.package_ids?.length ? formData?.package_ids : [])
                    .map(
                      (id) =>
                        packageOptions.find((opt) => opt.value === id.package_id)?.label
                    )
                    .filter(Boolean)
                    .join(", ") || "No package has been selected."}
                </div>
              </div>
            ) : (
              <div>
                <div className="d-flex align-items-center mb-1">
                  <label className="form-label me-2 mb-0">Select Packages</label>
                  <button
                    type="button"
                    className="btn btn-link p-0"
                    style={{ fontSize: "0.95em" }}
                    onClick={() => setShowAddPackageModal(true)}
                  >
                    + Add New Package
                  </button>
                </div>
                <Select
                  name="package_ids"
                  options={packageOptions}
                  isMulti
                  classNamePrefix="select"
                  styles={{
                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                  }}
                  menuPortalTarget={document.body}
  menuPosition="fixed"
                  onChange={(selectedOptions) => {
                    const selectedPackages = selectedOptions.map((opt) => ({
                      package_id: opt.value,
                      package_name: opt.label,
                      package_price: opt.price,
                    }));
                    handleChange({
                      target: {
                        name: "package_ids",
                        value: selectedPackages,
                      },
                    });
                  }}
                  value={
                    packageOptions.filter((opt) =>
                      Array.isArray(formData?.package_ids) &&
                      formData.package_ids.some((pkg) => pkg.package_id === opt.value)
                    )
                  }
                />
              </div>
            )}
          </div>
        </div>
        {totalRooms?.map((item, i) => (
          <div className="row">
            {/* Room Type Dropdown */}
            <div className="col-md-4 mb-3">
              {isViewOnly ? (
                <div className="view-only-field">
                  <label className="form-label">Room Type</label>
                  <div className="view-only-value">{selectedRoomType(i)}</div>
                </div>
              ) : (
                <FormSelect
                  label="Room Type"
                  name="room_type"
                  options={roomTypeOptions}
                  value={
                    formData?.rooms?.length ? formData?.rooms[i]?.room_type : ""
                  }
                  onChange={(e) => handleRoomChange(e, i)}
                  required
                  disabled={isViewOnly}
                />
              )}
            </div>

            {/* Room No Dropdown */}
            <div className="col-md-4 mb-3">
              {isViewOnly ? (
                <div className="view-only-field">
                  <label className="form-label">Room No</label>
                  <div className="view-only-value">{selectedRoomNo(i)}</div>
                </div>
              ) : (
                <FormSelect
                  label="Room No"
                  name="room_id"
                  options={roomNoOptions(i)}
                  value={
                    formData?.rooms?.length ? formData?.rooms[i]?.room_id : ""
                  }
                  onChange={(e) => handleRoomChange(e, i)}
                  required
                  disabled={isViewOnly}
                />
              )}
            </div>

            {/* Room Price Input */}
            <div className="col-md-4 mb-3">
              {isViewOnly ? (
                <div className="view-only-field">
                  <label className="form-label">Room Price</label>
                  <div className="view-only-value">
                    {formData?.rooms?.[i]?.price ? `₹${formData.rooms[i].price}` : "N/A"}
                  </div>
                </div>
              ) : (
                <FormInput
                  label="Room Price"
                  name="price"
                  type="number"
                  min={0}
                  disabled={!formData?.rooms[i]?.room_id}
                  value={formData?.rooms?.[i]?.price || ""}
                  onChange={e => handleRoomChange(e, i)}
                  required
                  placeholder="Enter price"
                />
              )}
            </div>

            {/* Room Capacity Input */}
            {/* <div className="col-md-3 mb-3">
            {isViewOnly ? (
              <div className="view-only-field">
                <label className="form-label">Capacity</label>
                <div className="view-only-value">
                  {formData?.rooms?.[i]?.capacity ? formData.rooms[i].capacity : "N/A"}
                </div>
              </div>
            ) : (
              <FormInput
                label="Capacity"
                name="capacity"
                type="number"
                min={1}
                disabled
                value={formData?.rooms?.[i]?.capacity || ""}
                onChange={e => handleRoomChange(e, i)}
                required
                placeholder="Enter capacity"
              />
            )}
          </div> */}
          </div>
        ))}
        {/* Remarks Field moved from ReservationDetails */}
        <div className="row">
          <div className="col-md-12 mb-3">
            {isViewOnly ? (
              <div className="view-only-field">
                <label className="form-label">Remarks</label>
                <div className="view-only-value">{formData.remarks || "-"}</div>
              </div>
            ) : (
              <FormInput
                type="textarea"
                label="Remarks"
                name="remarks"
                value={formData.remarks || ""}
                onChange={handleChange}
                placeholder="Remarks"
                disabled={isViewOnly}
              />
            )}
          </div>
        </div>
      </FormCard>
      {/* Render the modal OUTSIDE the parent form to avoid nested form submission issues */}
      <AddPackageModal
        show={showAddPackageModal}
        loading={addPkgLoading}
        errors={addPkgErrors}
        form={addPkgForm}
        onChange={handleAddPkgChange}
        onClose={() => setShowAddPackageModal(false)}
        onSave={handleAddPkgSave}
      />
    </>
  );
};

export default RoomDetails;
